import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiMenuItem(theme: Theme): Components['MuiMenuItem'] {
  return {
    styleOverrides: {
      root: {
        fontSize: '14px',
        '& > svg:first-of-type': {
          marginRight: theme.spacing(3),
        },
      },
    },
  };
}
